import { useEffect, useRef } from 'react';
import notificationService from '../services/NotificationService';

/**
 * Хук для автоматической разблокировки звука при движении мыши
 * @returns void
 */
export const useAutoUnlockAudio = () => {
  const mouseMoveTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isUnlockingRef = useRef<boolean>(false);

  useEffect(() => {
    // Функция для обработки движения мыши
    const handleMouseMove = () => {
      // Если звук уже разблокирован или идет процесс разблокировки, ничего не делаем
      if (notificationService.isAudioUnlocked() || isUnlockingRef.current) {
        return;
      }

      // Очищаем предыдущий таймаут, если он есть
      if (mouseMoveTimeoutRef.current) {
        clearTimeout(mouseMoveTimeoutRef.current);
      }

      // Устанавливаем новый таймаут для разблокировки звука
      mouseMoveTimeoutRef.current = setTimeout(async () => {
        try {
          isUnlockingRef.current = true;
          console.log('Attempting to unlock audio on mouse move');
          await notificationService.unlockAudio();
          console.log('Audio unlocked successfully on mouse move');
        } catch (error) {
          console.warn('Failed to unlock audio on mouse move:', error);
        } finally {
          isUnlockingRef.current = false;
        }
      }, 500); // Небольшая задержка, чтобы не разблокировать звук при каждом движении
    };

    // Добавляем обработчик события движения мыши
    document.addEventListener('mousemove', handleMouseMove);

    // Очищаем обработчик при размонтировании компонента
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      if (mouseMoveTimeoutRef.current) {
        clearTimeout(mouseMoveTimeoutRef.current);
      }
    };
  }, []);

  return null;
}; 